module.exports = __webpack_public_path__ + "img/p1-2-2.a75746ec.png";